export default function ConfirmModal({
  tag = "Confirm",
  title,
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  onConfirm,
  onCancel,
  danger = true,
  loading = false,
}) {
  const toneColor = danger ? "var(--hm-red)" : "var(--hm-mint)";

  return (
    <div
      className="fd-clear-overlay hm-logout-sheet-overlay"
      onClick={event => {
        if (event.target === event.currentTarget && !loading) onCancel?.();
      }}
    >
      <div className="fd-clear-sheet hm-logout-sheet" role="dialog" aria-modal="true" aria-label={title || tag} onClick={event => event.stopPropagation()}>
        <div className="fd-clear-sheet__chrome">
          <button className="fd-sheet-handle" type="button" onClick={onCancel} aria-label="Close confirmation" disabled={loading} />
          <button className="fd-clear-sheet__close" type="button" onClick={onCancel} aria-label="Close confirmation" disabled={loading}>×</button>
        </div>
        <div className="fd-clear-sheet__head">
          <div className="fd-clear-sheet__warn" style={{ color: toneColor }}>{tag}</div>
          <div className="fd-clear-sheet__title">{title}</div>
          {message && <div className="fd-clear-sheet__sub">{message}</div>}
        </div>
        <div className="fd-clear-sheet__foot">
          <button type="button" className="fd-clear-cancel hm-logout-cancel" onClick={onCancel} disabled={loading}>
            {cancelLabel}
          </button>
          <button
            type="button"
            className="fd-clear-confirm hm-logout-confirm"
            onClick={onConfirm}
            disabled={loading}
            style={{
              borderColor: danger ? undefined : "color-mix(in srgb, var(--hm-mint) 64%, var(--hm-line))",
              background: danger ? undefined : "color-mix(in srgb, var(--hm-mint) 9%, var(--hm-card-solid))",
              color: toneColor,
            }}
          >
            {loading ? "..." : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
